import { render, staticRenderFns } from "./infoList2.vue?vue&type=template&id=4213e80c&scoped=true&"
import script from "./infoList2.vue?vue&type=script&lang=js&"
export * from "./infoList2.vue?vue&type=script&lang=js&"
import style0 from "./infoList2.vue?vue&type=style&index=0&id=4213e80c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4213e80c",
  null
  
)

export default component.exports